import { useWatch } from "react-hook-form";

interface ConditionalFieldProps<TWatch extends string | string[]> {
  children: React.ReactNode;
  behavior: "show" | "hide";
  watch: TWatch;
  when: (value: TWatch extends string ? string : string[]) => boolean;
}

export function ConditionalField<TWatch extends string | string[]>({
  children,
  watch,
  when,
  behavior,
}: ConditionalFieldProps<TWatch>) {
  const value = useWatch({
    name: watch as any,
  });

  const matches = when(value);

  if (behavior === "show") {
    return matches ? <>{children}</> : null;
  }
  if (behavior === "hide") {
    return matches ? null : <>{children}</>;
  }

  return null;
}
